import LabelLang, { LabelLangString } from "component/LabelLang/label-lang";
import HtmlView from "component/htmlView/html-view";
import { API_BASE_URL } from "configs/AppConfig";
import { END_POINTS } from "constants/APIConstant";
import { DEFAULTS } from "constants/Defaults";
import { TRANSLATION_KEYS } from "constants/TranslationConstant";
import { DateFormater } from "functions/dateTimeFormat";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import useSWR from "swr";
// import SlideNewVersion from "../../shared/slideNewVersion/SlideNewVersion.js";
import NewsCardItem from "./components/news-card";
import "./newsVersion.scss";
// import ChevronIcon from "svg-icons/chevron-icon.js";
import Linkable from "component/LinkableComponent/linkable-component.js";
import MainButton from "component/shared/mainButton/MainButton";
import Divider from "component/divider/divider.js";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";

function NewsVersion() {
  const newsPinnedFetching = useSWR({
    url: END_POINTS.NEWS_GET_PINNED,
  });
  const currentLocale = useSelector(({ theme }) => theme.locale);

  const RenderPinnedData = () => {
    const newsData =
      newsPinnedFetching.error ||
      newsPinnedFetching.isLoading ||
      newsPinnedFetching.data === undefined ||
      newsPinnedFetching?.data?.data?.length <= 1
        ? []
        : newsPinnedFetching.data?.data?.slice(1, 4);
    const rendering = Object.keys(newsData).length > 0 && newsData.map(
      (
        { id, title, brief, content, image, publishDate, newsTranslation },
        index
      ) => {
        return (
          <NewsCardItem
            key={index}
            image={image}
            title={title}
            description={brief}
            publicationDate={publishDate}
            translations={newsTranslation}
            id={id}
          />
        );
      }
    );
    return rendering;
  };
  return (
    <div className="news-cc">
      <Divider />
      <div className="section-title">
        <FormattedMessage id="latest-news" />
      </div>

      <div className="row">
        <div className="col-12 col-lg-12">
          <div className="news-c">
            {newsPinnedFetching?.data?.data[0] ?
              <Linkable
                link={
                  newsPinnedFetching.data === undefined
                    ? null
                    : `mediaLanding/news/${newsPinnedFetching.data.data[0].id}`
                }
                data={newsPinnedFetching.data}
                className="item-news"
              >
                <img
                  className="up"
                  src={
                    newsPinnedFetching.data !== undefined &&
                    newsPinnedFetching.data?.data[0]?.image
                      ? `${API_BASE_URL}/${newsPinnedFetching.data?.data[0]?.image}`
                      : DEFAULTS.NEWS
                  }
                  alt="img-item"
                  loading="lazy"
                />
                <div className="home-main-pinned-card">
                  <div className="top-content">
                    <h5>
                      <DateFormater
                        value={
                          newsPinnedFetching.data === undefined
                            ? null
                            : newsPinnedFetching.data?.data[0]?.publishDate
                        }
                      />
                    </h5>
                    <h3 className={"title"}>
                      {newsPinnedFetching.data === undefined ? (
                        ""
                      ) : (
                        <LabelLang
                          id="title"
                          defaultValue={newsPinnedFetching.data?.data[0]?.title}
                          translations={
                            newsPinnedFetching.data?.data[0][
                              TRANSLATION_KEYS.NEWS
                            ]
                          }
                        />
                      )}
                    </h3>
                    {newsPinnedFetching.data === undefined ? (
                      ""
                    ) : (
                      <HtmlView
                        html={
                          newsPinnedFetching.data === undefined ? (
                            <></>
                          ) : (
                            LabelLangString({
                              id: "content",
                              currentLocale: currentLocale,
                              defaultValue:
                                newsPinnedFetching.data?.data[0]?.content,
                              translations:
                                newsPinnedFetching.data.data[0][
                                  TRANSLATION_KEYS.NEWS
                                ],
                            })
                          )
                        }
                      />
                    )}
                  </div>
                  <div className="rev-item item-up">
                    <div className="more">
                      <span>
                        <FormattedMessage id="read-news" />
                      </span>
                      <i className="fas fa-ellipsis-h"></i>
                    </div>
                  </div>
                </div>
              </Linkable>
              :
              <DataNotFound />
            }
          </div>
        </div>
      </div>

      <div className="row home-pinned-items">
        <RenderPinnedData />
      </div>
      <div className="row-r mt-4">
        <MainButton link={'./mediaLanding/news'} text={'all-news'} />
      </div>
    </div>
  );
}

export default NewsVersion;
